export function formatNumberWithCommas(value: number | bigint): string {
    const formatter: Intl.NumberFormat = new Intl.NumberFormat('ja-JP')
    return formatter.format(value)
}
